// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BrrS0","icon":"styles_icon__2uQLJ"};